import { injectGlobal } from 'styled-components';

/* eslint no-unused-expressions: 0 */
injectGlobal`
  html {
    // keep vertical scroll bar always display => prevent change viewport's width when scroll bar display
    overflow-y:scroll; 
  }
`;
